import React from 'react';

import ContentWithBackButton from 'components/PageLayout/ContentWithBackButton';
import Button from 'components/digifi-wrappers/Button';

import styles from './PoliciesPage.module.scss';

export const ConsentOfESignaturesContent = ({
  children,
}: {
  children?: React.ReactElement | React.ReactNode;
}) => {
  return (
    <div className={styles.consentContent}>
      <p className={styles.attention}>
        Please read this information carefully and print a copy and/or retain this information
        electronically for future reference.
      </p>
      <p>
        For purposes of this E-Consent, please note that Heights Finance Holding Co. provides
        management services for Southco Reinsurance, Inc. as well as its other affiliates and
        subsidiaries doing business as Covington Credit, Southern Finance, Quick Credit,
        loan.heightsfinance.com, and HeightsFinance.com, including: Covington Credit, Inc.;
        Covington Credit of Alabama, Inc.; Covington Credit of Georgia, Inc.; Covington Credit of
        Texas, Inc.; Quick Credit Corporation; Southern Finance of South Carolina, Inc.; and
        Southern Finance of Tennessee, Inc. (collectively referred to hereinafter as “we,” “us,” and
        “our”).
      </p>
      <p>
        As part of your relationship with us, we want to ensure you have all of the information you
        need to effectively manage your accounts. Our goal is to provide you with as many options as
        possible for receiving your account documents. We are required by law to give you certain
        information “in writing” – which means you are entitled to receive it on paper. However,
        with your prior consent, we may instead provide this information to you electronically. We
        also need your general consent to use electronic records and signatures throughout our
        relationship with you. So, before you use any of our services, we need your consent to using
        and accepting electronic signatures, records, and disclosures. This E-Consent notifies you
        of your rights when receiving disclosures, notices and information from us.
      </p>
      <p>
        By clicking “Sign-up,” “I Agree,” “Next,” “Submit,” or other links assenting to our terms,
        you are confirming that you have agreed to the terms and conditions of the E-Consent and
        that you have downloaded or printed a copy of this E-Consent for your records.
      </p>
      <p className={styles.contentSubtitle}>Scope of Consent</p>
      <p>
        Any disclosure, notice, record, document or other type of information that is provided to
        you, or that you sign, submit or agree to at our request, including but not limited to, the
        Loan Agreement, this E-Consent, the Truth in Lending disclosures set forth in the Loan
        Agreement, the Privacy Notice, change-in-terms notices, fee and transaction information,
        statements and notices of adverse action (collectively, “Communications”), may be sent to
        you electronically by using the Internet, a website, email, messaging services (including
        text messaging), and/or software applications (including applications for mobile or
        hand-held devices), either now or in the future.
      </p>
      <p className={styles.contentSubtitle}>Option for Paper or Non-Electronic Records</p>
      <p>
        We will not be obligated to provide any Communication to you in paper form unless you
        specifically request us to do so. You may obtain a paper copy of any Communications by
        logging into your account and printing a paper copy. You may also mail us your written
        request to Heights Finance Holding Co., P.O. Box 1947, Greenville, SC 29602. We will provide
        paper copies at no charge. We may always, in our sole discretion, provide you with any
        Communication via paper, even if you have chosen to receive it electronically.
      </p>
      <p className={styles.contentSubtitle}>Consenting to Do Business Electronically</p>
      <p>
        Before you decide to do business electronically with us, you should consider whether you
        have the required hardware and software capabilities described below.
      </p>
      <p className={styles.contentSubtitle}>Hardware and Software Requirements</p>
      <p>
        In order to receive electronic communications in connection with this transaction, you will
        need to use the following computer software and hardware: A PC or MAC compatible computer or
        other device capable of accessing the Internet and an Internet Browser software program that
        supports at least 128 bit encryption, such as Microsoft® Internet Explorer, Netscape® or
        Mozilla Firefox®. To read some documents, you may need a PDF file reader like Adobe® Acrobat
        Reader Xpdf® or Foxit®. You will also need a printer or a long-term storage device, such as
        your computer’s disk drive, to retain a copy of the Communications for future reference. If
        these requirements change while you are maintaining an active relationship with us, and the
        change creates a material risk that you may not be able to receive disclosures
        electronically, we will notify you of these changes.
      </p>
      <p className={styles.contentSubtitle}>Change to Your Contact Information</p>
      <p>
        You agree to provide us with your current email address for notices. If your email address,
        telephone number(s), or residence address changes, you must notify us of the change by
        logging into your account or contacting us in writing at Heights Finance Holding Co., P.O.
        Box 1947, Greenville, SC 29602.
      </p>
      <p className={styles.contentSubtitle}>Your Ability to Access Disclosures</p>
      <p>
        You agree that you are able to view and/or electronically store the information presented at
        this website. You also agree to print and retain a copy of this E-Consent for your records.
      </p>
      <p className={styles.contentSubtitle}>Consent</p>
      <p>
        You acknowledge and agree that when you click “I Agree”, you are providing your electronic
        signature on this E-Consent. By electronically signing this document, you acknowledge you
        have read this E-Consent and are agreeing to all of its terms and conditions. You agree that
        your electronic signature shall have the same force and effect and shall bind you to this
        document in the same manner and to the same extent as a physical signature would do, in
        accordance with the Electronic Signature in Global and National Commerce Act (ESIGN), to the
        extent applicable.
      </p>
      <p className={styles.contentSubtitle}>Withdrawing Consent</p>
      <p>
        You are free to withdraw this E-Consent at any time and at no charge. However, if you
        withdraw this E-Consent before receiving credit, this will prevent you from obtaining credit
        from us. If at any time you wish to withdraw this E- Consent, you can send us your written
        request by mail to Heights Finance Holding Co., PO Box 1947, Greenville, SC 29602, with the
        details of such request. If you decide to withdraw this E-Consent, the withdrawal will not
        affect the legal effectiveness, validity, and enforceability of prior electronic
        disclosures.
      </p>
      {children}
    </div>
  );
};

const ConsentOfESignatures = ({ withBackButton }: { withBackButton?: boolean }) => {
  const renderContent = () => {
    return (
      <ConsentOfESignaturesContent>
        <a
          className={styles.downloadLink}
          href={'/Consent-for-Electronic-Signatures.pdf'}
          target="_blank"
          title="Consent for Electronic Signatures"
        >
          <Button size="form" kind="secondary">
            Download E-Consent
          </Button>
        </a>
      </ConsentOfESignaturesContent>
    );
  };

  if (withBackButton) {
    return (
      <ContentWithBackButton title='Consent for Electronic Signatures, Records, and Disclosures ("E-Consent")'>
        {renderContent()}
      </ContentWithBackButton>
    );
  }

  return renderContent();
};

export default ConsentOfESignatures;
